module.exports = __webpack_public_path__ + "img/signal_cellular_1_bar-orange.4b85943b.svg";